// extracted by mini-css-extract-plugin
export var container = "_6HyCE";
export var grayShape = "FupCX";
export var mel = "fId1j";
export var peachShape = "_7-Bir";